import {Accordion, AccordionSummary, Typography} from "@material-ui/core"
import {CheckCircleOutline as OptedInCommIcon} from "@material-ui/icons"
import React from "react"
import styled from "styled-components"

import {CustomerEmailCommunicationOptedActivityPayload} from "@indebted/api"

function EmailCommunicationsOptedInActivity(
	panelId: number,
	{Title, HappenedAt}: {Title: string; HappenedAt: string; Payload: CustomerEmailCommunicationOptedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => void,
	classes: {summary: string},
) {
	return (
		<AccordionNoContent expanded={false}>
			<AccordionSummary>
				<OptedInCommIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
		</AccordionNoContent>
	)
}

const AccordionNoContent = styled(Accordion)`
	.MuiAccordionSummary-content {
		cursor: default;
	}
`

export {EmailCommunicationsOptedInActivity}
